import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IEventSignInSubmitData } from './IEventSignInSubmitData';
import { ProgressBarService } from '../../../shared/progress-bar/progress-bar.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
@UntilDestroy()
export class LoginFormComponent implements OnInit {
  @Output() clickSubmit = new EventEmitter<IEventSignInSubmitData>();

  readonly emailFormControl: FormControl;
  readonly passwordFormControl: FormControl;
  readonly formGroup: FormGroup;

  constructor(readonly progressBarService: ProgressBarService) {
    this.emailFormControl = new FormControl('', [Validators.required, Validators.email]);
    /**
     * Disabled password minlength validation for some time
     */
    this.passwordFormControl = new FormControl('', [Validators.required]);
    this.formGroup = new FormGroup({ email: this.emailFormControl, password: this.passwordFormControl });
  }

  ngOnInit() {
    this.progressBarService.isShown$.pipe(untilDestroyed(this)).subscribe((status) => {
      if (status) this.formGroup.disable();
      else this.formGroup.enable();
    });
  }

  onFormSubmit() {
    this.clickSubmit.emit({
      email: this.formGroup.value.email,
      password: this.formGroup.value.password,
    });
  }
}
